
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/e9b5bcc2ee5304cf6abe9f1074435c89/5c927ccc5c20b51ed9e6dafd52e7a4e9.png" 
                  alt="Vargas Legal Translation Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <div className="text-lg font-bold">Vargas Legal Translation</div>
                <div className="text-sm text-slate-300">Javier Vargas Carrillo</div>
              </div>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              {t('footerText')}
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('contactInfo')}</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-slate-400"></i>
                <span className="text-slate-300 text-sm">{t('address')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-slate-400"></i>
                <a href="mailto:javier@vtraduccion.com" className="text-slate-300 text-sm hover:text-white transition-colors cursor-pointer">
                  {t('email')}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-slate-400"></i>
                <a href="tel:+13852124967" className="text-slate-300 text-sm hover:text-white transition-colors cursor-pointer">
                  {t('phone')}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-instagram-line w-5 h-5 flex items-center justify-center text-slate-400"></i>
                <a href="https://instagram.com/vargas.legal.translation" target="_blank" rel="noopener noreferrer" className="text-slate-300 text-sm hover:text-white transition-colors cursor-pointer">
                  {t('instagram')}
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="/" className="block text-slate-300 text-sm hover:text-white transition-colors cursor-pointer">{t('home')}</a>
              <a href="/about" className="block text-slate-300 text-sm hover:text-white transition-colors cursor-pointer">{t('about')}</a>
              <a href="/services" className="block text-slate-300 text-sm hover:text-white transition-colors cursor-pointer">{t('services')}</a>
              <a href="/contact" className="block text-slate-300 text-sm hover:text-white transition-colors cursor-pointer">{t('contact')}</a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm">
            © 2025 Vargas Legal Translation. {t('allRightsReserved')}
          </p>
          <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-slate-400 text-sm hover:text-white transition-colors cursor-pointer mt-2 md:mt-0">
            Website Builder
          </a>
        </div>

      </div>
    </footer>
  );
}